import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTiposExamenesMedicos } from "../../../../../redux/actions/resolucion";
import InformarExamenesForm from "./InformarExamenesForm";

// No tiene initialValues ya que todos los valores son dinamicos traidos del back y son todos bool.

const InformarExamenesFormContainer = ({ callback, open, handleClose, values }) => {

  const dispatch = useDispatch();
  const tiposExamenesMedicos = useSelector((state) => state.resolucion.tiposExamenesMedicos.data);
  const [formValues, setFormValues] = useState();

  useEffect(() => {
    if (tiposExamenesMedicos.length === 0) {
      dispatch(getTiposExamenesMedicos());
    }
  }, [])

  useEffect(() => {
    if (tiposExamenesMedicos.length !== 0) {
      setFormValues({
        ...tiposExamenesMedicos.reduce((tiposExamenesMedicos, tipoExamenMedicos) => {
          tiposExamenesMedicos[tipoExamenMedicos.id] = {
            value: false
          };
          return tiposExamenesMedicos
        }, {}),
        ...values
      });
    }

  }, [open, tiposExamenesMedicos.length])

  const handleSubmit = (values) => {
    if (callback) {
      callback(values)
    }
    handleClose();
  }
  return (
    <InformarExamenesForm
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      initialValues={formValues}
      examenesMedicos={tiposExamenesMedicos}
    />
  )

}

export default InformarExamenesFormContainer;